import { Box, Container, Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomButton, CustomTable } from "../../../../global/components";
import strings from "../../../../global/constants/StringConstants";
import { handleErrorMessage } from "../../../../helpers/methods";
import { theme } from "../../../../utils/styles";
import currentNakshatraStyles from "./CurrentNakshatra.styles";
import { getCurrentNakshatraData } from "./CurrentNakshatraServices";
interface CustomProps {
  profileId: string;
  setIsLoading: Function;
}

const CurrentNakshatra = (props: CustomProps) => {
  const classes = currentNakshatraStyles;
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<any[]>([]);
  const [selectedNakshatra, setSelectedNakshatra] = useState("1");
  const [date, setDate] = useState<string>(dayjs().format("YYYY-MM-DD"));

  const tableHeader = [
    {
      name: `${t("planetName")}`,
      field: "planetName",
    },
    {
      name: `${t("oldSchool")}`,
      field: "oldSchool",
    },
    {
      name: `${t("newSchool")}`,
      field: "newSchool",
    },
  ];

  useEffect(() => {
    getCurrentNakshatraDetails();
  }, [selectedNakshatra, i18n.language]);

  const getCurrentNakshatraDetails = async () => {
    try {
      props.setIsLoading(true);
      const language = i18n.language.toLowerCase();
      const response = await getCurrentNakshatraData(
        props.profileId,
        selectedNakshatra,
        date,
        language
      );
      setData(response);
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      props.setIsLoading(false);
    }
  };

  const getCurrentNakshatra = () => {
    return (
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Stack direction={"column"} spacing={2} mb={2}>
          {[1, 2, 3].map((desc) => {
            return (
              <Box key={desc} sx={classes.legendDescText}>
                {t(`currentNakshatraDesc${desc}`)}
              </Box>
            );
          })}
        </Stack>
        <Stack
          direction={{ md: "row", xs: "column" }}
          spacing={{ md: 2, xs: 1 }}
          my={{ md: 3, xs: 1 }}
          justifyContent={"center"}
        >
          <Stack
            direction={{ sm: "row", xs: "column" }}
            spacing={{ sm: 2, xs: 1 }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={dayjs(date, "YYYY-MM-DD")}
                onChange={(newValue: any) => {
                  const formattedDate = newValue.format("YYYY-MM-DD");
                  setDate(formattedDate);
                }}
                sx={classes.datePicker}
              />
            </LocalizationProvider>
            <CustomButton
              label={t("calculate")}
              type={strings.PRIMARY}
              onClick={getCurrentNakshatraDetails}
              customClasses={{
                width: "fit-content",
                [theme.breakpoints.down("sm")]: {
                  fontSize: "14px",
                  py: "6px",
                  width: "100%",
                },
              }}
            />
          </Stack>
        </Stack>
        <Box sx={{ overflowX: "auto" }}>
          <CustomTable
            headers={tableHeader}
            rows={data}
            isRowPerPageEnable={true}
            rowsPerPage={20}
          />
        </Box>
      </Container>
    );
  };

  return getCurrentNakshatra();
};

export default CurrentNakshatra;
